<template>
  <svg
    id="422b3105-969d-41b5-acfe-f4aee29b8340"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 651.91 178.28"
  >
    <defs />
    <title>mcity-logo-informal-white</title>
    <path
      class="white"
      d="M415,69c.44-18.07-8.49-22.87-15.26-22.87-13.71,0-23.09,6.54-23.09,36.59,0,35.72,4.58,48.58,23.09,48.58,4.14,0,16.56-4.36,15.91-24.19h18.73c.65,30.93-22.43,38.78-34.64,38.78-23.29,0-41.81-7-41.81-55.53,0-32.25,3.7-58.81,41.81-58.81,22,0,34.85,12.84,33.77,37.46H415"
    />
    <path
      class="white"
      d="M455.12.09h20V19.26h-20Zm1.08,33.65h17.86v110H456.2Z"
    />
    <rect
      class="white"
      x="299.42"
      width="2.58"
      height="178.28"
    />
    <polyline
      class="maize"
      points="124.67 147.17 73.6 77.39 73.6 128.15 93.91 128.15 93.91 178.28 0 178.28 0 128.15 19.03 128.15 19.03 50.11 0 50.11 0 0 73.77 0 124.67 70.28 175.56 0 249.3 0 249.3 50.11 230.26 50.11 230.26 128.15 249.3 128.15 249.3 178.28 155.41 178.28 155.41 128.15 175.7 128.15 175.7 77.39 124.67 147.17"
    />
    <polygon
      class="white"
      points="585.75 177.87 604.49 177.87 651.91 33.74 632.53 33.74 606.16 123.26 605.74 123.26 579.38 33.74 558.68 33.74 595.93 143.74 585.75 177.87"
    />
    <path
      class="white"
      d="M507.64,33.74V8.3L525.5.24v33.5h17.2l4.6,13.51H525.5v67.3c0,7,0,15.9,16.34,15.9,1.31,0,4.13-.44,8.06-.86l4.46,13.23c-5.87.44-11.79,2.22-22.1,2.22-17,0-24.62-7-24.62-19.6V47.25H492.8V33.74h14.84"
    />
  </svg>
</template>

<script>
export default {
  name: 'BlockM', // component name
}
</script>

<style scoped>
  .white { fill:#fff; stroke: #fff }
  .maize { fill:#f5c400; }
</style>
